var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Delivery Companies"}},[_c('List'),_c('SetZone')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }